import { Grid } from "@mui/material";
import { getTime } from "date-fns";
import { Dispatch, SetStateAction, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Supplements from "../../../common/components/functional/Supplements/Supplements";
import FormSection from "../../../common/components/functional/formSection/FormSection";
import useIsLoading from "../../../hooks/useIsLoading";

type Props = {
  areTesVariationsValid: boolean;
  setPeriodStartDateIsRequired: Dispatch<SetStateAction<boolean | null>>;
};

const OrderTemplateSupplements = ({
  areTesVariationsValid,
  setPeriodStartDateIsRequired,
}: Props) => {
  const { t } = useTranslation();
  const { watch, setValue } = useFormContext();

  const isLoading = useIsLoading(["supplements"]);

  const onAddSupplement = (key: string, mode: string) => {
    const currentSupplements = watch("supplements");
    const updatedSupplements = {
      ...currentSupplements,
      [key]: { mode },
    };
    setValue("supplements", updatedSupplements, { shouldDirty: true });
    return true; // TODO: Return true if successful
  };

  const onEditSupplement = (key: string, mode: string) => {
    // TODO: supplement type must be ON_OFF to allow editing?
    const currentSupplements = watch("supplements");
    const updatedSupplement = {
      ...currentSupplements[key],
      mode,
    };
    const updatedSupplements = {
      ...currentSupplements,
      [key]: updatedSupplement,
    };

    setValue("supplements", updatedSupplements, { shouldDirty: true });
    return true; // TODO: Return true if successful
  };

  const onDeleteSupplement = (key: string) => {
    const currentSupplements = watch("supplements");
    const updatedSupplements = { ...currentSupplements };
    delete updatedSupplements[key];
    setValue("supplements", updatedSupplements, { shouldDirty: true });
    return true; // TODO: Return true if successful
  };

  const epoch = useMemo(() => getTime(new Date()), []);

  return (
    <FormSection title={t("talentProfile:supplementsToShow")}>
      <Grid item xs={3} />
      <Grid item xs={9}>
        <Supplements
          areTesVariationsValid={areTesVariationsValid}
          tesId={watch("tes.id")}
          tesSelections={watch("tesVariation")}
          date={epoch}
          supplements={watch("supplements")}
          isLoading={isLoading}
          onAdd={onAddSupplement}
          onEdit={onEditSupplement}
          onDelete={onDeleteSupplement}
          setPeriodStartDateIsRequired={setPeriodStartDateIsRequired}
          modalTitle={t("order:supplementsModalTitle").toUpperCase()}
          modalSupplementSelectLabel={t("order:supplementSelectLabel")}
          modalSupplementOptionalityLabel={t(
            "order:supplementOptionalityLabel",
          )}
          tableWidth="407px"
        />
      </Grid>
    </FormSection>
  );
};

export default OrderTemplateSupplements;
